export const faqs = [
  {
    "question": "What do I get for $27?",
    "answer": "The 40-page guide with 12 complete lessons, printable challenges, progress tools and all 5 bonuses. One payment, no subscription."
  },
  {
    "question": "Can I use it if I’m new to badminton?",
    "answer": "Yes. It’s designed for teachers and coaches working with beginners aged 9–12, with clear instructions, diagrams and teaching cues."
  },
  {
    "question": "What equipment do I need?",
    "answer": "The standard setup uses 12 rackets, 24 shuttlecocks, floor markers and safe practice space for 24 learners. A six-racket rotation plan is included. Equipment is not supplied."
  },
  {
    "question": "Can I adapt the lesson length or difficulty?",
    "answer": "Yes. The 40-minute lessons include easier and harder options, plus a 30-minute alternative."
  },
  {
    "question": "How do I receive the pack?",
    "answer": "Your download links arrive by email after payment is approved. All resources are English-language PDFs to save or print."
  },
  {
    "question": "Do I need to buy any extras?",
    "answer": "No. The $27 pack includes the complete beginner unit and 5 bonuses. Any extra packs offered at checkout are optional."
  }
];
